export default __webpack_public_path__ + "static/media/update_login.96b6f8ba.svg";